<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <HeaderButtons
        :pageTitle="'ご注文内容の確認'"
        :isShowCartButton="false"
        :isShowLoginButton="false"
      />
    </div>
    <div id="page-content" class="page-content">
      <section class="page-content__form-group">
        <ProductListTable :isInitialShowActionButton="false" />
      </section>
      <section class="page-content__form-group">
        <Accordion :content="inputSummary" :isInitialOpen="true"></Accordion>
      </section>
      <h4 class="page-content__input-forms-title">■ お支払い情報の入力</h4>
      <div class="col-sm-8 col-sm-offset-2 page-content__input-forms">
        <section class="page-content__form-group">
          <!-- <div v-for="payment in payments" :key="payment.payBy">
            <label class="big-radio">
              <input
                type="radio"
                name="course-radio"
                :value="payment.payBy"
                v-model="payment.payBy"
                @change="validate"
                class="big-radio--input"
              />
              <span class="big-radio--dummy-input"></span>
              <span class="big-radio--label-text">{{ payment.payByName }}</span>
            </label>
          </div> -->
          <label v-show="canPayByInvoice" class="big-radio">
            <input
              type="radio"
              name="course-radio"
              value="D"
              v-model="payment.payBy"
              @change="validate"
              class="big-radio--input"
            />
            <span class="big-radio--dummy-input"></span>
            <span class="big-radio--label-text">請求</span>
          </label>
          <label v-show="canPayByForMembreGuest" class="big-radio">
            <input
              type="radio"
              name="course-radio"
              value="A"
              v-model="payment.payBy"
              @change="validate"
              class="big-radio--input"
            />
            <span class="big-radio--dummy-input"></span>
            <span class="big-radio--label-text">クレジットカード決済</span>
          </label>
          <!-- <label v-show="canPayByForMembreGuest" class="big-radio">
            <input
              type="radio"
              name="course-radio"
              value="E"
              v-model="payment.payBy"
              @change="validate"
              class="big-radio--input"
            />
            <span class="big-radio--dummy-input"></span>
            <span class="big-radio--label-text">コンビニ決済</span>
          </label> -->
          <label v-show="canPayByForMembreGuest" class="big-radio">
            <input
              type="radio"
              name="course-radio"
              value="F"
              v-model="payment.payBy"
              @change="validate"
              class="big-radio--input"
            />
            <span class="big-radio--dummy-input"></span>
            <span class="big-radio--label-text">PayPay決済</span>
          </label>
          <label class="big-radio">
            <input
              type="radio"
              name="course-radio"
              value="B"
              v-model="payment.payBy"
              @change="validate"
              class="big-radio--input"
            />
            <span class="big-radio--dummy-input"></span>
            <span class="big-radio--label-text">事前振り込み</span>
          </label>
          <label class="big-radio">
            <input
              type="radio"
              name="course-radio"
              value="C"
              v-model="payment.payBy"
              @change="validate"
              class="big-radio--input"
            />
            <span class="big-radio--dummy-input"></span>
            <span class="big-radio--label-text">代引き郵便</span>
          </label>
        </section>
        <section v-show="payment.payBy === 'B'" class="page-content__form-group">
          <label for="name" class="input-form__label-title">振込予定日</label>
          <aside class="input-form__date-wrapper">
            <select
              id="pay-day-year"
              name="pay-day-year"
              v-model="payment.payAtYear"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">年</option>
              <option v-for="year in years" v-bind:value="year">{{ year }}年</option>
            </select>
            <select
              id="pay-day-month"
              name="pay-day-month"
              v-model="payment.payAtMonth"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">月</option>
              <option v-for="month in months" v-bind:value="month">{{ month }}月</option>
            </select>
            <select
              id="pay-day-day"
              name="pay-day-day"
              v-model="payment.payAtDay"
              @blur="validate()"
              class="input-form__selectbox input-form__selectbox--date"
            >
              <option value="">日</option>
              <option v-for="day in payDays" v-bind:value="day">{{ day }}日</option>
            </select>
          </aside>
          <span class="input-form__label-validation-message">{{ this.error.payment.payAt }}</span>
        </section>
      </div>
      <section class="page-content__form-group">
        <aside v-show="payment.payBy === 'A'">
          <div class="page-content__banktransfer-wrapper">
            GMOイプシロン社のクレジットカード決済ページに移動します。<br />
            <ul class="page-content__payment-image-list">
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_ae.gif" alt="AmericanExpress" />
              </li>
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_diners.gif" alt="Dinvers" />
              </li>
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_jcb.gif" alt="JCB" />
              </li>
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_master.gif" alt="Master" />
              </li>
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_visa.gif" alt="VISA" />
              </li>
            </ul>
          </div>
        </aside>
        <aside v-show="payment.payBy === 'B'">
          <div class="page-content__banktransfer-wrapper">
            事前振り込みをご希望の方は、お申込み確認後、お振込み先口座をメールにて送付いたしますので、ご確認の程宜しくお願い致します。<br />
            <span style="color: red">※なお、振り込み手数料はお客様でご負担ください。</span><br />
          </div>
        </aside>
        <aside v-show="payment.payBy === 'C'">
          <div class="page-content__banktransfer-wrapper">
            合計金額 ¥33,000（税込）以上の場合、 代引き手数料として別途¥1,100（税込）発生します。
          </div>
        </aside>
        <aside v-show="payment.payBy === 'E'">
          <div class="page-content__banktransfer-wrapper">
            GMOイプシロン社のコンビニ決済ページに移動します。<br />
            <ul class="page-content__payment-image-list">
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_711.gif" alt="SevenEleven" />
              </li>
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_familymart.gif" alt="FamilyMart" />
              </li>
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_lawson.gif" alt="Lawson" />
              </li>
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_mini.gif" alt="MiniStop" />
              </li>
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_seico.gif" alt="SeicoMart" />
              </li>
            </ul>
          </div>
        </aside>
        <aside v-show="payment.payBy === 'F'">
          <div class="page-content__banktransfer-wrapper">
            GMOイプシロン社のPayPay決済ページに移動します。<br />
            <ul class="page-content__payment-image-list">
              <li class="page-content__payment-image-item">
                <img src="../../../../images/payment/logo_paypay.gif" alt="PayPay" />
              </li>
            </ul>
          </div>
        </aside>
      </section>
      <section v-show="!requestBodyError" class="page-content__form-group">
        <span class="input-form__label-validation-message">{{ this.requestBodyError }}</span>
      </section>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/application-form" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-secondary rounded-pill" @click="navigate">
              前ページに戻る
            </button>
          </router-link>
        </div>
        <div class="page-footer__next-button-inner">
          <button
            v-bind:disabled="!isSubmit"
            id="nextButton"
            class="btn btn-danger rounded-pill"
            @click="register"
          >
            ご注文を確定する
          </button>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
    <div id="loading" v-show="isShowDialog" class="page-content__overlay">
      <div id="content" v-show="isShowResult" class="page-content__overlay-contents">
        <article>
          <section>
            <div class="page-content__article-section-body--dialog-message">
              <p class="page-content__dialog-message--error">{{ this.resultMessage }}</p>
              <p>
                BSAC担当者まで上記メッセージまたはエラーコードをご連絡ください。<br />
                TEL: 03-5297-5656 / e-mail: order@bsac.jp
              </p>
            </div>
          </section>
        </article>
        <div class="page-footer__next-button-wrapper">
          <div class="page-footer__next-button-inner">
            <router-link to="/" custom v-slot="{ navigate }">
              <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
                トップ画面に戻る
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
  </div>
</template>

<script>
import Accordion from 'vues/common/components/parts/Accordion';
import errorValues from 'constant/shopping-order/error-values';
import HeaderButtons from 'vues/shopping-order/components/parts/HeaderButtons';
import ProductListTable from 'vues/shopping-order/components/parts/ProductListTable';
import selectboxValues from 'utils/selectbox-values';
import selections from 'constant/selections';
import validations from 'utils/validations';
import { VueLoading } from 'vue-loading-template';

export default {
  components: {
    Accordion,
    HeaderButtons,
    ProductListTable,
    VueLoading,
  },
  computed: {
    /**
     * クレジットカード決済可否を判定する
     * メンバーとゲストのみ可能
     */
    canPayByForMembreGuest: {
      cache: false,
      get() {
        return (
          this.$store.getters['partner/partnerType'] === 3 ||
          this.$store.getters['partner/partnerType'] === null
        );
      },
    },
    /**
     * 請求での決済可否を判定する
     *
     */
    canPayByInvoice: {
      cache: false,
      get() {
        const partnerType = this.$store.getters['partner/partnerType'];
        if (!partnerType) return false;
        if (partnerType === 3) return false;
        return true;
      },
    },
    /**
     * 入力概要
     */
    inputSummary: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/inputSummary'];
      },
    },
    /**
     * 次の画面に遷移可能かを判定する
     */
    isSubmit: function () {
      let result = true;
      result &= this.error.payment.payAt === null;
      result &= this.error.payment.payBy === null;
      result &= this.requestBodyError === null;

      if (result) this.saveDataInStore();
      return result;
    },
    /**
     * 月リストを取得する
     */
    months: function () {
      return selections.months();
    },
    /**
     * 振込日リストを取得する
     */
    payDays: function () {
      return selections.days({
        year: this.payment.payAtYear,
        month: this.payment.payAtMonth,
      });
    },
    /**
     * 支払い方法リスト
     */
    payments: function () {
      return selections.payment.list;
    },
    /**
     * リクエストボディを取得する
     *
     */
    requestBody: {
      cache: false,
      get() {
        return this.$store.getters['shoppingOrder/requestBodyForRegister'];
      },
    },
    /**
     * 結果メッセージ
     */
    resultMessage: function () {
      let message = null;
      if (this.registerResult === null) return message;

      message = this.registerResult.message + '\n\n';

      return message;
    },
    /**
     * 年リストを取得する
     */
    years: function () {
      return selections.scheduledYears();
    },
  },
  created() {
    this.error = Object.assign({}, errorValues.error);
    this.payment = this.$store.getters['shoppingOrder/payment'];
    this.validate({ all: true });
  },
  data() {
    return {
      error: null,
      payment: null,
      isShowDialog: false,
      isShowResult: false,
      registerResult: null,
      requestBodyError: null,
    };
  },
  methods: {
    /**
     * 申込内容を登録する
     * 動的に遷移先を切り分けるためbeforeRouteLeaveメソッドは使わない
     */
    register: async function () {
      this.isShowDialog = true;

      this.$store.commit('loading/show');
      try {
        // 登録する
        const res = await this.$store.dispatch('shoppingOrder/register');
        //console.debug(`res:${JSON.stringify(res)}`);
        if (res.success && res.status === 201 && res.message === null) {
          // 完了画面に遷移する
          this.$router.push('/completed');
        }
        this.isShowResult = true;
        this.registerResult = res;
      } finally {
        this.$store.commit('loading/close');
      }
    },
    /**
     * 入力値をストアに保存する
     */
    saveDataInStore: function () {
      this.$store.commit('shoppingOrder/setPayment', this.payment);
    },
    /**
     * 入力値を検証する
     */
    validate: function () {
      // console.debug(`value:${JSON.stringify(this.payment)}`);
      /**
       * お支払い方法
       */
      this.error.payment.payBy = validations.validateChars({
        value: this.payment.payBy,
        size: 1,
        requiredCheck: true,
      });
      if (this.payment.payBy === 'B') {
        /**
         * 振込予定日
         */
        this.error.payment.payAt = validations.validateDate({
          value: {
            year: this.payment.payAtYear,
            month: this.payment.payAtMonth,
            day: this.payment.payAtDay,
          },
          requiredCheck: true,
        });
        /**
         * 振込予定日の未来日チェック
         */
        if (this.error.payment.payAt === null) {
          this.error.payment.payAt = validations.validateFutureDate({
            value: {
              year: this.payment.payAtYear,
              month: this.payment.payAtMonth,
              day: this.payment.payAtDay,
            },
          });
        }
      } else {
        this.error.payment.payAt = null;
      }
      // ブラウザバックをした際に申込内容が消える事象を防止する対応
      if (!this.requestBody) {
        this.requestBodyError =
          '申込内容に不備があります。再度ログインし直してお申し込みください。';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/input-form.scss';
@import 'stylesheets/page.scss';
@import 'stylesheets/big-radio.scss';

.page-content__price-table {
  width: 80%;
  min-width: 300px;
  max-width: 500px;
  margin: 2rem auto 2rem auto;
  padding: 1rem 1rem 1rem 1rem;
  font-size: 0.8rem;
  text-align: center;
  vertical-align: middle;

  &-tr-title {
    width: 125px;
  }

  &-tr-price {
    font-size: 1.8rem;
    color: #ff0033;
  }
}

.page-content__banktransfer-wrapper {
  width: 80%;
  min-width: 300px;
  max-width: 600px;
  height: auto;
  margin: 2rem auto 2rem auto;
  padding: 1rem 1rem 1rem 1rem;
}

.page-content__dialog-message--error {
  white-space: pre-wrap;
  color: red;
  font-weight: bold;
}

.page-content__payment-image-list {
  margin: 2rem auto auto auto;
  display: flex;
  justify-content: center;
}

.page-content__payment-image-item {
  list-style: none;
}
</style>
